import { Box, IconButton, Label, Text } from '@moosend/mooskin';
import * as React from 'react';
import { Link } from 'react-router-dom';

interface ITypeSelectorProps {
	title: string;
	options: { label: string; route: string }[];
}

export const TypeSelector: React.FC<ITypeSelectorProps> = (props) => {
	const { title, options } = props;
	const [dropdown, setDropdown] = React.useState(false);

	return (
		<Box
			bgColor={dropdown ? '#ffffff' : ''}
			d="flex"
			align="center"
			h="100%"
			flex={1}
			mr={5}
			cursor="pointer"
			boxShadow={dropdown ? 'md' : ''}
			position="relative"
			onMouseEnter={() => setDropdown(true)}
			onMouseLeave={() => setDropdown(false)}
		>
			<Box mx={15} h="100%" flex={1} d="flex" align="center" justify="space-between">
				<Label fontSize={22}>{title}</Label>
				<IconButton>{dropdown ? 'expand_less' : 'expand_more'}</IconButton>
			</Box>
			{dropdown && (
				<Box boxShadow="md" bgColor="#ffffff" position="absolute" top={78} right={0} left={0} zIndex={2}>
					{options.map((item) => {
						return (
							<Link key={item.route} to={item.route}>
								<Text py={5} px={15} _hover={{ 'background-color': '#f4f4f4', color: '#3fbaca' }}>
									{item.label}
								</Text>
							</Link>
						);
					})}
				</Box>
			)}
		</Box>
	);
};
